import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async getProcessosCriarOs ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/filtro/criarOs`
    })
    return data
  },
  async getProcessos ({ commit }, { dados }) {
    if (dados && dados.ordem && dados.ordem === 'responsavel') {
      dados.ordem = 'usuario'
    }
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/filtro`
    })
    return data
  },
  async getProcessosByCredenciados ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/filtro/findByCredenciados`
    })
    return data
  },
  async getPortarias ({ commit }, { dados }) {
    if (dados && dados.ordem && dados.ordem === 'responsavel') {
      dados.ordem = 'usuario'
    }
    const data = await axios({
      method: 'post',
      data: dados,
      url: `publico/filtroPortaria`
    })
    return data
  },
  async getPublicacoes ({ commit }, { dados }) {
    if (dados && dados.ordem && dados.ordem === 'responsavel') {
      dados.ordem = 'usuario'
    }
    const data = await axios({
      method: 'post',
      data: dados,
      url: `publico/filtroPublicacoes`
    })
    return data
  },
  getProcessosVtn ({ commit }, { dados }) {
    return axios({
      method: 'post',
      data: dados,
      url: `processo/filtroVtn`
    })
  },
  async getProcessosOrdemServico ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/ordemServicofiltro`
    })
    return data
  },
  async iniciaAnalise ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `processo/${dados.idProcesso}/${dados.tipoAcao}/iniciaAnalise`,
      error: true
    })
    return data
  },
  async iniciaAnaliseCcr ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `processo/${dados.idProcesso}/${dados.tipoAcao}/iniciaAnaliseCcr`,
      error: true
    })
    return data
  },
  async tramitarComAcao ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `processo/tramitarComAcao/${dados.acao}/processo/${dados.processoId}`
    })
    return data
  },
  async tramitar ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `processo/tramitar/${dados.processo}`
    })
    return data
  },
  async tramitarByPerfil ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `processo/tramitarByPerfil/${dados.processo}`
    })
    return data
  },
  async tarefa ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `processo/tarefa/${dados.processo}`
    })
    return data
  },

  async subcaixaAtual ({ commit }, idProcesso) {
    const data = await axios({
      method: 'GET',
      url: `processo/subcaixaAtual/${idProcesso}`
    })
    return data
  },
  async finalizarDae ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/finalizarDae`
    })
    return data
  },
  async analiseConjunta ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/analiseConjunta`
    })
    return data
  },
  async exportarCsvAnalise ({ commit }, dados) {
    const file = await axios({
      method: 'POST',
      url: 'processo/exportarCsv/analise',
      data: dados,
      responseType: 'blob'
    })

    return file
  },

  async exportarTitulosLote ({ commit }, idsProcesso) {
    const file = await axios({
      method: 'POST',
      url: 'despacho/pdf/titulo/processo/lote',
      data: idsProcesso,
      responseType: 'blob',
      loader: false
    })

    return file
  },

  async finalizaAssinatura ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/assinar/titulo`,
      assinatura: true,
      notMessage: true
    })
    return data
  },
  async finalizaAssinaturaRetificacaoTitulo ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/assinar/retificacao/titulo`,
      assinatura: true,
      notMessage: true
    })
    return data
  },

  async assinarProcessosGov ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/assinar/titulo/gov/adicionarFila`,
      assinatura: true,
      notMessage: true
    })
    return data
  },

  async finalizaAssinaturaExtratoSentenca ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/assinar/extrato_sentenca`,
      assinatura: true
    })
    return data
  },

  async finalizaAssinaturaOficio ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/assinar/oficio`,
      assinatura: true,
      notMessage: true
    })
    return data
  },
  async finalizaAssinaturaLaudo ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/assinar/documento/despacho`,
      assinatura: true
    })
    return data
  },
  async getProcessoById ({ commit }, idProcesso) {
    const data = await axios({
      method: 'get',
      url: `processo/processo/${idProcesso}`
    })
    return data
  },
  async retificarProcesso ({ commit }, dados) {
    await axios({
      method: 'post',
      data: dados,
      url: `processo/retificar`
    })
  },
  async encerrarRetificacaoCancelamento ({ commit }, protocolo) {
    await axios({
      method: 'post',
      url: `processo/encerrar/retificacao/cancelamento/clausula/resolutiva/${protocolo}`
    })
  },
  async desarquivarProcesso ({ commit }, { idProcesso, dados }) {
    return axios({
      method: 'post',
      data: dados,
      url: `processo/desarquivar/${idProcesso}`
    })
  },
  async gerarBoletoDesarquivamento ({ commit }, { idProcesso, dados }) {
    return axios({
      method: 'post',
      data: dados,
      url: `processo/gerarBoletoDesarquivamento/${idProcesso}`
    })
  },
  async cancelarBoletoDesarquivamento ({ commit }, numeroProcesso) {
    return axios({
      method: 'post',
      url: `processo/cancelarBoletoDesarquivamento?numeroProcesso=${numeroProcesso}`
    })
  },
  async getCustoBoletoDesarquivamento ({ commit }, numeroProtocolo) {
    const data = axios({
      method: 'get',
      url: `processo/desarquivar/custoBoleto/${numeroProtocolo}`
    })
    return data
  },

  async cancelarRetificacaoProcesso ({ commit }, dados) {
    await axios({
      method: 'post',
      data: dados,
      url: `processo/cancelarRetificacao`
    })
  },
  async avocarProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/avocar`
    })
    return data
  },
  async getTipoProcesso ({ commit }) {
    const result = await axios({
      method: 'GET',
      url: `publico/tiposProcessos`
    })
    return result
  },
  async getTitulo ({ commit }, idProcesso) {
    const data = await axios({
      method: 'get',
      url: `despacho/verifica/titulo/${idProcesso}`
    })
    return data
  },
  async getStatusAtual ({ commit }, idProcesso) {
    const data = await axios({
      method: 'GET',
      url: `processo/${idProcesso}/statusAtual`
    })
    return data
  },
  async retornarSetor ({ commit }, despacho) {
    await axios({
      method: 'POST',
      url: `processo/retornarSetor`,
      data: despacho
    })
  },
  async arquivarProcesso ({ commit }, despacho) {
    await axios({
      method: 'POST',
      url: 'processo/arquivarProcesso',
      data: despacho
    })
  },
  async shape ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/shape/exportar/${idProcesso}`,
      responseType: 'blob'

    })
    return result
  },

  async checkAnalisePendente ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/${idProcesso}/checkAnalisePendente`
    })
    return result
  },

  async checkAnaliseManual ({ commit }, idProcesso) {
    const result = await axios({
      method: 'POST',
      url: `processo/${idProcesso}/confirmaAnaliseManual`
    })
    return result
  },

  async getDadosEnviarCartorio ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/${idProcesso}/getDadosEnviarCartorio`
    })
    return result
  },

  async getCsvProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      responseType: 'blob',
      data: dados,
      url: `processo/exportarCsv`,
      loader: false
    })
    return data
  },

  async atualizarProcessoAssinatura ({ commit }, dados) {
    await axios({
      method: 'POST',
      data: dados,
      url: 'processo/atualizarStatusProcessoParaAssinar'
    })
  },

  async getInformacoesCustasCertidao ({ commit }, idProcesso) {
    return axios({
      method: 'GET',
      url: `calculo/custa/certidao?idProcesso=${idProcesso}`
    })
  },

  async findProcessoCalculoCusta ({ commit }, idProcesso) {
    const data = await axios({
      method: 'get',
      url: `processo/processoCalculoCusta/${idProcesso}`
    })
    return data
  },

  async getCompararRetificacoes ({commit}, dados) {
    const data = await axios({
      method: 'get',
      url: `processo/compararRetificacoes/${dados.protocolo}/${dados.versaoSelecionada}/${dados.versaoSelecionadaComparacao}`
    })
    return data
  },
  async getDadosCadastroById ({ commit }, idProcesso) {
    const data = await axios({
      method: 'get',
      url: `processo/getDadosCadastroVtn/${idProcesso}`
    })
    return data
  },
  async acusarDisponibilidade ({ commit }, idProcesso) {
    return axios({
      method: 'post',
      url: `processo/acusarDisponibilidade/${idProcesso}`
    })
  },
  async statusProcessoFila ({ commit }, idProcesso) {
    return axios({
      method: 'post',
      url: `processo/${idProcesso}/statusProcessoFila`
    })
  },
  async iniciarValidaoManual ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/iniciarValidacaoManual/${idProcesso}`
    })
    return result
  },
  async getShapesByNumerosProcessos ({ commit }, form) {
    const data = await axios({
      method: 'POST', url: 'processo/getShapesByNumerosProcessos', data: form
    })
    return data
  },
  async existeProcesso ({ commit }, numProcesso) {
    const response = await axios({
      method: 'GET',
      url: `processo/existeProcesso?numeroProcesso=${numProcesso}`
    })
    return response
  },

  async getProcessosVinculadosReurb ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/getSubProcessosReurbColetivo/${idProcesso}`
    })
    return result
  },

  async csvIndividuaisByColetivo ({ commit }, idProcesso) {
    const result = await axios({
      method: 'POST',
      url: `processo/csvIndividuaisByColetivo/${idProcesso}`,
      responseType: 'blob'
    })
    return result
  },
  async findIdProcessoByProtocolo ({ commit }, numeroProtocolo) {
    const data = axios({
      method: 'get',
      url: `processo/getIdProcessoByProtocolo/${numeroProtocolo}`
    })
    return data
  },
  async getProcessoColetivoByProcessoIndividual ({ commit }, {idProcesso, versaoCadastro}) {
    const result = await axios({
      method: 'GET',
      url: `processo/getProcessoColetivoByProcessoIndividual/${idProcesso}/${versaoCadastro}`
    })
    return result
  },
  async enviaDocumentosVistoriaRemota ({ commit }, dados) {
    const result = await axios({
      method: 'POST',
      url: `processo/enviaDocumentosVistoriaRemota`,
      data: dados
    })
    return result
  },
  async getProcessosUc ({commit}) {
    return axios({
      method: 'get',
      url: 'processo/getProcessosUc'
    })
  },
  async getProcessosConsultorExterno ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `processo/getProcessosConsultorExterno`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/processo.js